export default "__VITE_ASSET__UrxhLNdx__"